import { TabPanel } from '@tryhackme/thm-ui-components';
import { useParams } from 'react-router-dom';
import { PublicProfileTabPanelProps } from 'src/features/public-profile/components/public-profile-tab-panel/public-profile-tab-panel.types';
import { BadgesTab } from 'src/features/public-profile/components/badges-tab/badges-tab';
import { CompletedRoomsTab } from 'src/features/public-profile/components/completed-rooms-tab/completed-rooms-tab';
import { CreatedRoomsTab } from 'src/features/public-profile/components/created-rooms-tab/created-rooms-tab';
import { YearlyActivityTab } from 'src/features/public-profile/components/yearly-activity-tab/yearly-activity-tab';
import { TicketsTab } from 'src/features/public-profile/components/tickets-tab/tickets-tab';
import { PublicProfileTabPanelValue } from 'src/features/public-profile/public-profile.types';
import { SkillsMatrixContent } from 'src/features/skills-matrix/components/matrix-content';
import { useFeatureIsOn } from 'src/common/growthbook';
import { CertificatesTab } from '../certificates-tab';
import { useGetPublicProfileGeneralDataQuery } from '../../public-profile.slice';
const componentTabs = (userId: string, dateSignUp: string, isSkillsMatrixEnabled: boolean, username: string) => ({
  [PublicProfileTabPanelValue.BADGES]: <BadgesTab userId={userId} username={username} />,
  [PublicProfileTabPanelValue.COMPLETED_ROOMS]: <CompletedRoomsTab userId={userId} />,
  [PublicProfileTabPanelValue.CREATED_ROOMS]: <CreatedRoomsTab userId={userId} />,
  [PublicProfileTabPanelValue.YEARLY_ACTIVITY]: <YearlyActivityTab userId={userId} dateSignUp={dateSignUp} />,
  [PublicProfileTabPanelValue.TICKETS]: <TicketsTab userId={userId} />,
  [PublicProfileTabPanelValue.CERTIFICATES]: <CertificatesTab />,
  ...(isSkillsMatrixEnabled && {
    [PublicProfileTabPanelValue.SKILLS_MATRIX]: <SkillsMatrixContent />
  })
});
export const PublicProfileTabPanel = ({
  value,
  userId
}: PublicProfileTabPanelProps) => {
  const {
    username
  } = useParams();
  const isSkillsMatrixEnabled = useFeatureIsOn('skills-matrix-public-profile');
  const {
    data
  } = useGetPublicProfileGeneralDataQuery({
    username: username ?? ''
  });
  const dateSignUp = data?.data?.dateSignUp || '';
  const tabs = componentTabs(userId, dateSignUp, isSkillsMatrixEnabled, username ?? '');
  return <TabPanel value={value} data-sentry-element="TabPanel" data-sentry-component="PublicProfileTabPanel" data-sentry-source-file="public-profile-tab-panel.tsx">{tabs[value]}</TabPanel>;
};